import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";

export const SetupInvalidLink = ({ reason }) => {
  const { t } = useTranslation();
  return <AuthLayout
    icon={AlertTriangle}
    title={t("setup.invalidLinkTitle")}
    subtitle={reason}
    footer={<>{t("register.alreadyHaveAccount")}{" "}
      <Link to="/login" data-testid="setup-login" className="text-primary font-medium hover:underline">{t("register.signIn")}</Link>
    </>}>
    <p data-testid="setup-invalid-link" className="text-sm text-foreground text-center">{t("setup.invalidLinkBody")}</p>
    <p className="text-xs text-muted-foreground text-center mt-3">
      {t("setup.stillNoAccess")}{" "}
      <a data-testid="setup-support" href="mailto:mentoriafabioborges@gmail.com" className="text-primary hover:underline">{t("common.supportEmail")}</a>.
    </p>
  </AuthLayout>;
};
